import { mockRecordsTabQueryOperationQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

import { RECORD_SCHEMA_JSON } from '@sbu/configs.mocks';

export const handlers = [
  mockRecordsTabQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          recordSchema: JSON.stringify(RECORD_SCHEMA_JSON),
        },
      });
    }
  ),
];
